module.exports = __webpack_public_path__ + "static/assets/74e124e354b52e57877f74b5ff383d6e.svg";